import React, { useContext } from 'react';
import { KatDataTable } from '@amzn/katal-react';
import { CreateCaseConstants } from 'src/constants/ProjectConstants';
import { getColumnsConfig } from './tableConfiguration';
import { useNavigate } from 'react-router-dom';
import { IGetCaseListItem } from 'src/state/slice/models/CaseLifecycleTypes';
import styled from 'styled-components';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const TableContainerLayout = styled.div``;
export interface TableContainerProps {
  data: Array<IGetCaseListItem>;
}
const TableContainer: React.FC<TableContainerProps> = ({ data }) => {
  const { createCaseBundle } = useContext(TranslationContext);
  const tableHeader = createCaseBundle.getMessage(
    CreateCaseConstants.CASE_LISTING_TEXT,
  );
  let navigate = useNavigate;

  return (
    <TableContainerLayout>
      <KatDataTable
        id="data-table"
        data-testid="data-table"
        titleLabel={tableHeader}
        className="section"
        columns={getColumnsConfig({ navigateFn: navigate })}
        rowData={data}
      />
    </TableContainerLayout>
  );
};

export default TableContainer;
